var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_447_2287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.5 60C47.0685 60 60.5 46.5685 60.5 30C60.5 13.4315 47.0685 0 30.5 0C13.9315 0 0.5 13.4315 0.5 30C0.5 46.5685 13.9315 60 30.5 60Z",
    fill: "#48B02C",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9896 36.3681L41.0028 20.3549C41.2309 20.1276 41.5397 20 41.8617 20C42.1836 20 42.4924 20.1276 42.7205 20.3549L44.2771 21.9115C44.5043 22.1395 44.6319 22.4483 44.6319 22.7703C44.6319 23.0922 44.5043 23.401 44.2771 23.6291L28.2459 39.6423C28.0187 39.8641 27.7137 39.9883 27.3961 39.9883C27.0785 39.9883 26.7735 39.8641 26.5462 39.6423L24.9896 38.0857C24.7624 37.8577 24.6348 37.5488 24.6348 37.2269C24.6348 36.9049 24.7624 36.5961 24.9896 36.3681Z",
    fill: "#48B02C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9982 26.5991L29.7493 36.3681C29.9765 36.5961 30.1041 36.9049 30.1041 37.2269C30.1041 37.5488 29.9765 37.8576 29.7493 38.0857L28.2106 39.6244C27.9825 39.8516 27.6737 39.9793 27.3518 39.9793C27.0298 39.9793 26.721 39.8516 26.493 39.6244L16.724 29.8733C16.4967 29.6453 16.3691 29.3365 16.3691 29.0145C16.3691 28.6926 16.4967 28.3838 16.724 28.1557L18.2806 26.617C18.5086 26.3897 18.8175 26.2621 19.1394 26.2621C19.4613 26.2621 19.7702 26.3719 19.9982 26.5991Z",
    fill: "#48B02C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_2287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0194aed4918d85f68fb7a2877c2e839f.svg";
export { ForwardRef as ReactComponent };